<template>
  <div>
    <input
      type="text"
      v-model="displayDate"
      @input="formatInput"
      @keydown="handleBackspace"
      @blur="validateDate"
      placeholder="dd/mm/yyyy"
      maxlength="10"
      inputmode="numeric"
      class="form-control form-control-sm"
      :id="this.idInput"
      autocomplete="off"
    />
  </div>
</template>

<script>
export default {
  emits: ['input', 'update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: ''
    },
    idInput: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      displayDate: this.formatToDisplay(this.getExternalValue())  // Inicializa o input com o formato correto
    };
  },
  watch: {
    modelValue(newVal) {
      this.displayDate = this.formatToDisplay(newVal);
    },
    value(newVal) {
      if (this.modelValue === undefined) {
        this.displayDate = this.formatToDisplay(newVal);
      }
    }
  },
  methods: {
    getExternalValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },

    emitValue(value) {
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },

    // Formata a data no formato dd/mm/yyyy para o input
    formatToDisplay(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    // Formata a entrada automaticamente com "/"
    formatInput(event) {
      let input = event.target.value.replace(/\D/g, '');  // Remove qualquer caractere não numérico

      if (input.length >= 2 && input.length < 4) {
        input = `${input.slice(0, 2)}/${input.slice(2)}`;
      } else if (input.length >= 4) {
        input = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;
      }

      this.displayDate = input;
    },

    // Trata o backspace para permitir apagar o "/"
    handleBackspace(event) {
      const cursorPosition = event.target.selectionStart;
      
      if (event.key === 'Backspace' && (cursorPosition === 3 || cursorPosition === 6)) {
        event.preventDefault(); // Impede o comportamento padrão
        this.displayDate = this.displayDate.slice(0, cursorPosition - 1) + this.displayDate.slice(cursorPosition);
        this.$nextTick(() => {
          event.target.setSelectionRange(cursorPosition - 1, cursorPosition - 1); // Move o cursor para a posição correta
        });
      }
    },

    // Converte a data inserida para o formato yyyy-mm-dd ao perder o foco
    validateDate() {
      if (!this.displayDate || this.displayDate.trim() === '') {
        this.emitValue('');
        return;
      }

      const parts = this.displayDate.split('/');
      if (parts.length === 3) {
        const [day, month, year] = parts;
        if (day.length === 2 && month.length === 2 && year.length === 4) {
          const formattedDate = `${year}-${month}-${day}`;
          this.emitValue(formattedDate);  // Emite o valor formatado para o componente pai
          return;
        }
      }

      this.emitValue('');
    }
  }
};
</script>
